import { render } from "./simpleChart.vue?vue&type=template&id=8da44314"
import script from "./simpleChart.vue?vue&type=script&lang=js"
export * from "./simpleChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__